import { render, staticRenderFns } from "./UsePasswordLogin.vue?vue&type=template&id=48fddfbe"
import script from "./UsePasswordLogin.vue?vue&type=script&lang=js"
export * from "./UsePasswordLogin.vue?vue&type=script&lang=js"
import style0 from "./UsePasswordLogin.vue?vue&type=style&index=0&id=48fddfbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports